/**
 * Formate le numéro de commande pour afficher seulement les 2 derniers chiffres
 * Exemple: 13789 devient 89
 * @param orderNumber Le numéro de commande complet
 * @returns Les 2 derniers chiffres du numéro de commande
 */
export const formatOrderNumber = (orderNumber: string | number | null | undefined): string => {
  if (!orderNumber) return 'N/A';

  const orderStr = orderNumber.toString();

  // Si le numéro a moins de 2 caractères, retourner tel quel
  if (orderStr.length <= 2) return orderStr;

  // Retourner les 2 derniers caractères
  return orderStr.slice(-2);
};

/**
 * Retourne le numéro de commande complet (pour logs, etc.)
 * @param orderNumber Le numéro de commande
 * @returns Le numéro de commande complet
 */
export const getFullOrderNumber = (orderNumber: string | number | null | undefined): string => {
  if (!orderNumber) return 'N/A';
  return orderNumber.toString();
};
